import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Loading } from '../controls';

export function EventRelatedSection({
  icon,
  title,
  onAdd,
  addLabel,
  addButtonClassName = '',
  loading = false,
  emptyMessage = 'None yet.',
  contentOnly = false,
  addPlacement = 'footer',
  children,
}) {
  const hasItems = React.Children.count(children) > 0;

  let body = null;
  if (loading) {
    body = <Loading />;
  } else if (contentOnly) {
    body = children;
  } else if (hasItems) {
    body = <div className="event-related-list">{children}</div>;
  } else if (emptyMessage) {
    body = <p className="event-related-empty">{emptyMessage}</p>;
  }

  const addButton =
    onAdd && addLabel ? (
      <button
        type="button"
        className={`btn-add-section m-0${addButtonClassName ? ` ${addButtonClassName}` : ''}`}
        onClick={onAdd}
      >
        <FontAwesomeIcon icon={['fas', 'plus']} />
        {addLabel}
      </button>
    ) : null;

  return (
    <section className="bethere-form-section w-full">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <h2 className="m-0 flex items-center gap-2 text-2xl font-bold text-[#121212]">
          {icon ? (
            <FontAwesomeIcon
              icon={icon}
              className="text-[var(--bethere-primary)]"
            />
          ) : null}
          {title}
        </h2>
        {addPlacement === 'header' ? addButton : null}
      </div>

      {body}

      {addPlacement === 'footer' ? addButton : null}
    </section>
  );
}

export function EventRelatedItemRow({ label, meta, onEdit, onDelete }) {
  return (
    <div className="event-related-row">
      <button
        type="button"
        className="event-related-row-label"
        onClick={onEdit}
      >
        {label}
      </button>
      {meta ? <span className="event-related-row-meta">{meta}</span> : null}
      <button
        type="button"
        className="bethere-action-btn"
        aria-label={`Edit ${label}`}
        title="Edit"
        onClick={onEdit}
      >
        <FontAwesomeIcon icon={['fas', 'pen']} />
      </button>
      {onDelete ? (
        <button
          type="button"
          className="bethere-action-btn bethere-action-btn--danger"
          aria-label={`Delete ${label}`}
          title="Delete"
          onClick={onDelete}
        >
          <FontAwesomeIcon icon={['fas', 'trash']} />
        </button>
      ) : null}
    </div>
  );
}
